import { theme, Typography } from 'antd';
import { TiStarFullOutline } from 'react-icons/ti';
import { useContext } from 'react';
import { ConfigContext } from '../../Config';
import type { Recipe } from 'src/graphql/generated/graphql';

type RatingIndicatorRecipe = Pick<Recipe, 'id' | 'averageRating' | 'ratingCount'>;

interface RatingIndicatorProps {
  recipe: RatingIndicatorRecipe;
  colorOk?: string;
  colorEmpty?: string;
}

const { Text } = Typography;

export default function RatingIndicator({ recipe, colorOk, colorEmpty = 'grey' }: RatingIndicatorProps) {
  const { token } = theme.useToken();
  const reviewCountEnabled = useContext(ConfigContext).state?.reviewCountEnabled ?? false;
  const displayValue = recipe.averageRating ? Number(recipe.averageRating).toFixed(1) : 'N/A';
  const activeColor = colorOk ?? token.colorWarning;
  return (
    <div id={`rating-indicator_${recipe.id}`} style={{ display: 'flex', alignItems: 'center', gap: 6, height: 22 }}>
      <TiStarFullOutline style={{ color: recipe.averageRating ? activeColor : colorEmpty, fontSize: 15 }} />
      <Text type="secondary" style={{ fontSize: 13 }}>{displayValue}{reviewCountEnabled ? ` (${recipe.ratingCount})` : ''}</Text>
    </div>
  );
}
